import css from 'styled-jsx/css';

const styles = css.global`#open-finance-passo-a-passo {
  background: #FBFBFB;
  overflow: hidden;
}

.open-finance-passo-a-passo-p1 {
  padding: 32px 0;
  position: relative;
}

.open-finance-passo-a-passo-p1 .ctn-home-24 {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.open-finance-passo-a-passo-p1 .passo-a-passo-titulos {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.open-finance-passo-a-passo-p1 .passo-a-passo-titulos .passo-a-passo-titulo {
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 48px; 
}

.open-finance-passo-a-passo-p1 .passo-a-passo-titulos .passo-a-passo-subtitulo {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; 
}

.open-finance-passo-a-passo-p1 .passo-a-passo-itens {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.open-finance-passo-a-passo-p1 .passo-a-passo-item {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}

.open-finance-passo-a-passo-p1 .passo-a-passo-item b {
  color: #C00;
  font-family: "SantanderText";
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px;
}

.open-finance-passo-a-passo-p1 .passo-a-passo-item a {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  text-decoration-line: underline;
  text-decoration-style: solid;
  word-break: break-word;
}

.open-finance-passo-a-passo-p1 .img-passo-a-passo {
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0.15;
}

.open-finance-passo-a-passo-p2 {
  padding: 32px 0;
}

.open-finance-passo-a-passo-p2 .ctn-home-24 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.open-finance-passo-a-passo-p2 .passo-a-passo-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.open-finance-passo-a-passo-p2 .passo-a-passo-card-texto {
  color: #444;
  text-align: center;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
}


@media (min-width: 992px) {
  .open-finance-passo-a-passo-p1 {
    padding: 64px 0;
  }

  .open-finance-passo-a-passo-p1 .passo-a-passo-titulos {
    gap: 0;
  }

  .open-finance-passo-a-passo-p1 .passo-a-passo-titulos .passo-a-passo-titulo {
    font-size: 40px;
    line-height: 60px; 
  }
    
  .open-finance-passo-a-passo-p1 .img-passo-a-passo {
    top: auto;
    bottom: 0;
    right: 0;
  }

  .open-finance-passo-a-passo-p2 {
    padding: 32px 0 56px;
  }

  .open-finance-passo-a-passo-p2 .ctn-home-24 {
    flex-direction: row;
    gap: 48px;
  }

  .open-finance-passo-a-passo-p2 .passo-a-passo-card {
    width: 386px;
  }

  .open-finance-passo-a-passo-p2 .passo-a-passo-card:first-child {
    width: 328px;
  }
}`;

export default styles;